export enum PrintoutFormat {
    PDF = "pdf",
    DOCX = "docx",
    XLSX = "xlsx"
}
